<template lang="pug">
    div.chat
        div.chatToggle( @click="toggleChat")
            transition(name="fade")
                div(v-if="showChat")
                    span Hide chat
                    v-icon(color="primary") keyboard_arrow_left
                div(v-else)
                    span Show chat
                    v-icon(color="primary") keyboard_arrow_right
        div.chatMessages(id="chat-container" :class="{showChat: showChat}")
</template>

<script>
    import VueTypes from 'vue-types';
    import chat from '~api/chat';
    export default {
        $_veeValidate: {
            validator: 'new'
        },
        props: {
            chatId: VueTypes.string.def('')
        },
        data() {
            return {
                token: null,
                watcher_count: 0,
                channel: null,
                client: null,
                messages: [],
                newMessage: '',
                showChat: true,
                state: null
            };
        },
        async created() {
            // gerenrate clientside token from server
            await this.getToken();
            await this.setUser();
            await this.initChat();
        },
        methods: {
            /**
             * Get user token for chat
             */
            async getToken() {
                const resp = await chat.createTokenWeavy();

                if (resp.ok) {
                    this.token = resp.data.token;
                }
            },

            /**
             * Set user in chat Api
             */
            async setUser() {
                await chat.initChatWeavy(this.chatId);
                Weavy.url = 'https://df27ba3826f2425fbd65f5feed28f13d.weavy.io';
                Weavy.tokenFactory = async () => this.token;
            },

            /**
             * Initialize chat
             */
            async initChat() {
                const chat = new Chat({ uid: this.chatId });
                document.getElementById('chat-container').append(chat);
            },

            /**
             * Toggle chat
             */
            toggleChat() {
                this.showChat = !this.showChat;
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import "../../assets/style/_variables.styl"

    .chat
        height: calc(100% - 40px)
        width: 260px
        position: absolute
        left: 0
        top: 0
        z-index: 3
        padding: 5px

    .chatMessages
        overflow-y: scroll;
        scrollbar-width: none; /* Firefox */
        -ms-overflow-style: none;  /* Internet Explorer 10+ */
        padding-bottom: 10px
        width: 100%
        height: calc(100% - 30px)
        position: absolute
        top: 34px
        left: -100%
        transition: left 0.3s

        &.showChat
            left: 0

        &::-webkit-scrollbar
            width: 0;  /* Remove scrollbar space */
            background: transparent;  /* Optional: just make scrollbar invisible */

    .chatToggle
        cursor: pointer
        margin: 5px
        display: inline-block
        padding: 0 5px
        border-radius: 10px
        background-color: rgba($theme.white, 0.6)
        color: $theme.primary

        div
            display: flex
            align-items: center
</style>
